<template>
  <div class="app-label d-inline-block" :class="{disabled}">
    <i v-if="iconClass" :class="['mar-r-2', iconClass]"></i>
    <span class="labels-body">
      <slot></slot>
    </span>
    <app-icon-with-action
      v-if="editable"
      @click="disabled ? false : $emit('edit')"
      class="mar-l-2"
      :disabled="disabled"
    >
      <i class="fal fa-pencil"></i>
    </app-icon-with-action>
    <app-icon-with-action
      v-if="deletable"
      @click="disabled ? false : $emit('delete')"
      class="mar-l-2"
      :disabled="disabled"
    >
      <i class="fal fa-times-circle"></i>
    </app-icon-with-action>
  </div>
</template>

<script>
import AppIconWithAction from '@/components/htmlHelpers/AppIconWithAction'
export default {
  name: 'AppLabel',
  components: { AppIconWithAction },
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    deleteTitle: {
      type: String,
      default: 'Delete'
    },
    editTitle: {
      type: String,
      default: 'Edit'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.app-label {
  background-color: $gray-200;
  border: 1px solid $gray-200;
  border-radius: 4px;
  padding: 2px 6px;
  color: $text-color-gray;
  &.disabled {
    background-color: $gray-100;
    border: 1px solid $gray-100;
    color: $text-color-gray-disabled;
    .labels-body {
      color: $text-color-gray-disabled;
    }
  }
}
.labels-body {
  max-width: 200px;
  color: $text-color-gray;
  word-break: break-word;
}
</style>
